import * as React from 'react'
import {Route, Routes, Navigate, useParams} from 'react-router-dom'
import Loader from '../../components/common/Loader/Loader'
import HealthCheck from '../../components/HealthCheck/HealthCheck'
import Logout from '../../components/Logout/Logout'
const Home = React.lazy(() => import('../Home/Home'))
const WorkInProgress = React.lazy(() => import('../Home/WorkInProgress'))
const Profile = React.lazy(() => import('../Profile/Profile'))
const NodeArticle = React.lazy(() => import('../NodeArticle/NodeArticle'))
const Wiki = React.lazy(() => import('../Wiki/Wiki'))
const Restaurant = React.lazy(() => import('../Restaurant/Restaurant'))
const ThinkTank = React.lazy(() => import('../ThinkTank/ThinkTank'))
const WorkSpace = React.lazy(() => import('../WorkSpace/WorkSpace'))
const NotFound = React.lazy(() => import('../404/NotFound'))
const Notification = React.lazy(() => import('../Notification/Notification'))
const Bureaucracy = React.lazy(() => import('../Bureaucracy/Bureaucracy'))
const DirectlyTo = React.lazy(() => import('../DirectlyTo/DirectlyTo'))
const Search = React.lazy(() => import('../Search/Search'))
const CookieConsentPolicy = React.lazy(
  () => import('../../components/CookieConsentPolicy/CookieConsentPolicy')
)

// Wrapper component for Profile with citrixId param
const ProfileWithUserId = () => {
  const {citrixId} = useParams()
  return <Profile userId={citrixId || ''} />
}

// Wrapper component for 404 with custom props
const NotFoundPage = () => (
  <NotFound
    header="OH NO! THIS PAGE DOESN'T EXIST OR WAS REMOVED"
    paragraph="We are sorry! The page you were searching for cannot be found."
  />
)

const RouteHandler: React.FC<any> = () => {
  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home/*" element={<Home />} />
        <Route path="/profile/*" element={<Profile userId="" />} />
        <Route
          path="/view-employee/:citrixId/*"
          element={<ProfileWithUserId />}
        />
        <Route path="/health" element={<HealthCheck />} />
        <Route path="/news/:nid" element={<NodeArticle />} />
        <Route path="/socialnews/:nid" element={<NodeArticle />} />
        <Route path="/hotel/:nid" element={<NodeArticle />} />
        <Route path="/airline/:nid" element={<NodeArticle />} />
        <Route path="/wiki/*" element={<Wiki />} />
        <Route path="/think-tank/:page/*" element={<ThinkTank />} />
        <Route path="/restaurant" element={<Restaurant />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/work-space" element={<WorkSpace />} />
        <Route path="/notification" element={<Notification />} />
        <Route
          path="/notification/*"
          element={<Navigate to="/notification" replace />}
        />
        <Route path="/wip" element={<WorkInProgress />} />
        <Route path="/bureaucracy/*" element={<Bureaucracy />} />
        <Route path="/directly-to/*" element={<DirectlyTo />} />
        <Route path="/search/*" element={<Search />} />
        <Route path="/node/:nid" element={<NodeArticle />} />
        <Route path="/cookies-consent" element={<CookieConsentPolicy />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </React.Suspense>
  )
}

export default RouteHandler
